import React, { useState } from 'react'
import { Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import useGetAllData from '../../hooks/useGetAllData'
import useUrlQueryParams from '../../hooks/useUrlQeryParams'
import { FILE_URL } from '../../config/utils'
import useGetOneData from '../../hooks/useGetOneData'
import CustomPagination from '../../components/pagination'

const AdminstrativeOffice = ({ spesialization_id }: { spesialization_id: number | undefined }) => {
  const { t } = useTranslation()
  const [isOpen, setisOpen] = useState<boolean>(false)
  const [_id, set_id] = useState<number | undefined>()
  const totalItems = localStorage?.getItem('totalItems')

  function getIdFromUrl(): string | undefined {
    const path = window.location.pathname; 
    const parts = path.split('/');
  
    if (parts.length >= 3) {
      return parts[2].replace(':', '');
    }
  
    return undefined;
  }
  
  const id = getIdFromUrl();

  const handleOk = () => {
    setisOpen(false);
  };

  const handleCancel = () => {
    setisOpen(false);
  };


  const { urlValue, writeToUrl } = useUrlQueryParams({
    currentPage: 1,
    perPage: 10,
  });

  const { data } = useGetAllData<any>({
    queryKey: ['tmp_people', urlValue.perPage, urlValue.currentPage, id],
    url: 'tmp_people',
    urlParams: { PerPage: urlValue.perPage, page: urlValue.currentPage, 'categories.id': id },
    options: {
      refetchOnWindowFocus: false,
      retry: 1,
      enabled: !!id,
    },
  });


  const { data: arbitratorView } = useGetOneData<any>({
    queryKey: ["tmp_people", _id],
    url: `tmp_people/${_id}`,
    options: {
      enabled: !!_id
    }
  })

  return (
    <div className='mt-6 pb-10'>
      <div className="grid grid-cols-12 gap-5">
        {
          data?.map((item: any) => (
            <div className="xl:col-span-3 md:col-span-4 sm:col-span-6 col-span-12 rounded-lg overflow-hidden flex flex-col items-center relative hover:cursor-pointer" onClick={() => { setisOpen(true); set_id(item?.id) }}>
              <div className='relative w-40 h-40 border-[6px] border-main_color rounded-full overflow-hidden flex justify-center items-center'>
                <img src={`${FILE_URL}/${item?.avatar?.contentUrl}`} alt="person" className='object-cover w-[100%] h-[100%]' />
              </div>
              <h3 className='font-bold text-main_color my-3 max-w-[80%] text-center'>{item?.name}</h3>
            </div>
          ))
        }
        {
          data?.length ? 
          <div className="col-span-12 justify-end">
            <CustomPagination
              totalCount={Number(totalItems)}
              currentPage={urlValue.currentPage}
              perPage={urlValue.perPage}
            />
          </div> : null
        }
      </div>

      <div className="arbitrator_view">
        <Modal open={isOpen} onOk={handleOk} closable={false} wrapClassName="arbitrator_view_modal" onCancel={handleCancel} centered footer>
          <div className="arbitrator_view_header pt-16">
            <img src={`${FILE_URL}/${arbitratorView?.avatar?.contentUrl}`} alt="image" className="w-[150px] h-[150px] rounded-[50%] block text-center mx-auto" />
          </div>
          <div className="rounded-lg px-2 pb-5" style={{ background: 'linear-gradient(180deg, rgba(217, 217, 217, 0) 0%, rgba(28, 114, 166, 0.2) 100%)' }}>
            <h3 className="font-semibold text-base text-center my-1 text-main_color">{arbitratorView?.name}</h3>
            <p className="text-[#868686] text-base">{t('Specialization')}</p>
            {
              arbitratorView?.specializations?.map((element: any) => (
                <span className="text-black text-center font-medium">{element?.name}, </span>
              ))
            }
            <p className="text-[#868686] text-base">{t('Work experience')}</p>
            <p className="font-semibold">{arbitratorView?.title}</p>
            <p className="text-[#868686] text-base">{t('Additional information')}</p>
            <p className="font-semibold">{arbitratorView?.description}</p>
          </div>
        </Modal>
      </div>

    </div>
  )
}

export default AdminstrativeOffice